import React, { Component } from "react";

import DelayNotification from "./delaynotification.js";
import settings from "./../settings.js";
import { Link } from "react-router-dom";

import Clock from "../assets/clock.svg";
import Scrollbars from "react-custom-scrollbars";

class DelayNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, data: [] };
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_delayed_deliveries/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }
  removeItem(newsID) {
    fetch(
      settings.server_url +
        "set_newsitem_read/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        newsID
    )
      .then((res) => res.json())
      .then((response) => {})
      .catch((error) => console.error("Error:", error));
  }

  clickRemoveHandler = (e, index) => {
    e.preventDefault();

    let newData = this.state.data;
    newData[index].removed = true;

    this.setState({ data: newData });

    this.removeItem(newData[index].nieuws_id);

    setTimeout(() => {
      let newData = this.state.data;
      newData.splice(index, 1);

      this.setState({ data: newData });
    }, 300);
  };

  openNotification = (e, index) => {
    let newData = this.state.data;

    newData[index].opened = true;

    this.setState({ data: newData });
  };

  render() {
    return (
      <div className="gridItem">
        <div className="gridHeader">
          {/*
          <div className="gridHeaderIcon">
            <img src={Clock} alt="" />
          </div>
          */}
          <div className="gridHeaderTitle">Uitgestelde leveringen</div>
          {this.state.data.length > 0 && (
            <div className="gridHeaderCount delays">
              <span>{this.state.data.length}</span>
            </div>
          )}

          <div className="gridHeaderAll">
            <Link
              to={{
                pathname: "/orders",
                state: { activeTab: "5" }, // Tab 5 is for "UITGESTELDE LEVERINGEN"
              }}
              className="">
              Bekijk alle
            </Link>
          </div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              {this.state.data.map((notification, index) => (
                <DelayNotification
                  clickRemoveHandler={(e) => this.clickRemoveHandler(e, index)}
                  openNotification={(e) => this.openNotification(e, index)}
                  notification={notification}
                  key={index}
                />
              ))}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              <div className="returned noReturns">
                <div className="ReturnDetails">
                  <div className="ReturnTitle">Geen uitgestelde leveringen</div>
                </div>
              </div>
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default DelayNotifications;
